import { getNodeIdComposer } from '@utils';
import { RootPrefix } from './constants';

export const partsId = getNodeIdComposer(RootPrefix, 'parts');
